import { render, staticRenderFns } from "./FormSchemaRenderer.vue?vue&type=template&id=1898cb24&scoped=true"
import script from "./FormSchemaRenderer.vue?vue&type=script&lang=js"
export * from "./FormSchemaRenderer.vue?vue&type=script&lang=js"
import style0 from "./FormSchemaRenderer.vue?vue&type=style&index=0&id=1898cb24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1898cb24",
  null
  
)

export default component.exports